export const gtmSearchKeywordEvent = (searchQuery: string) => {
  return {
    event: 'Search_termto',
    eventCategory: 'Search',
    eventLabel: searchQuery,
  };
};

export default gtmSearchKeywordEvent;
